import "./App.css";
import About from "./components/About";
import Navbar from "./components/Navbar";
import TextForm from "./components/TextForm";

import { useState } from "react";
import Alert from "./components/Alert";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  const [mode, setMode] = useState("light");
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 1500);
  };
  const toggleMode = () => {
    if (mode === "light") {
      setMode("dark");
      document.body.style.backgroundColor = "#90EE90";
      showAlert("dark mode enabled", "success");
      document.title = "textxUtils -greenMode";
    } else {
      setMode("light");
      document.body.style.backgroundColor = "white";
      showAlert("light mode enabled", "success");
      document.title = "textxUtils -lightMode";
    }
  };

  //for red mode
  const toggleRedMode = () => {
    if (mode === "light") {
      setMode("red");
      document.body.style.backgroundColor = "red";
      document.title = "textxUtils -redMode";

      showAlert("red mode enabled", "success");
    } else {
      setMode("light");
      document.body.style.backgroundColor = "white";
      showAlert("light mode enabled", "success");
      document.title = "textxUtils -redMode";
    }
  };
  const toggleBlueMode = () => {
    if (mode === "light") {
      setMode("blue");
      document.body.style.backgroundColor = "#ADD8E6";
      showAlert("blue mode enabled", "success");
      document.title = "textxUtils -blueMode";
    } else {
      setMode("light");
      document.body.style.backgroundColor = "white";
      showAlert("light mode enabled", "success");
      document.title = "textxUtils -lightMode";
    }
  };
  return (
    <>
      <Router>
        {/* <NavBar title="NelsonBlogs" aboutText="ABout nelsblog"/>       removing aboutText here as we can acess it from default in Navbar.js */}
        <Navbar
          title="NelsonBlog"
          mode={mode}
          toggleMode={toggleMode}
          toggleRedMode={toggleRedMode}
          toggleBlueMode={toggleBlueMode}
        />
        <Alert alert={alert} />
        <div className="container my-3">
          <Routes>
            <Route exact path="/about" element={<About mode={mode} />} />
            <Route
              exact
              path="/"
              element={
                <TextForm showAlert={showAlert} heading=" Enter your Text  " mode={mode} />
              }
            />
          </Routes>

          {/* <TextForm showAlert={showAlert} heading="Enter your text" mode={mode} /> */}
        </div>
      </Router>
    </>
  );
}

export default App;
